"use strict";import{tag as r}from"../custom-tag.js";export function questionIcon({height:t=16,width:e=16,hidden:a=!1,title:l="Question"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${a?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <mask
        id="question_svg__mask0_6875_6515"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M19.457 5.326A10.007 10.007 0 0 0 4.53 18.656 9.94 9.94 0 0 0 12.005 22a10.007 10.007 0 0 0 7.452-16.673m1.476 7.17A8.953 8.953 0 1 1 7.117 4.482a8.955 8.955 0 0 1 13.816 8.016"
        />
        <path
          fill="currentColor"
          d="M12.52 16.732h-1.054v1.053h1.054zm-.527-10.534a3.69 3.69 0 0 0-3.687 3.686v.527H9.36v-.527a2.634 2.634 0 0 1 5.267 0c0 1.104-.798 1.82-1.9 2.81-.355.319-.73.656-1.106 1.032l-.373.372.745.745.373-.373c.36-.36.723-.685 1.064-.992 1.207-1.084 2.25-2.02 2.25-3.594a3.69 3.69 0 0 0-3.687-3.686"
        />
      </mask>
      <g mask="url(#question_svg__mask0_6875_6515)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=question.js.map
